import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getArrayBuffer, getURLFromTemplate } from '@antv/l7-utils';
import { VectorTile } from '@mapbox/vector-tile';
import Protobuf from 'pbf';
var DEFAULT_CONFIG = {
  tileSize: 256,
  minZoom: 0,
  maxZoom: Infinity,
  zoomOffset: 0
}; // const TILE_SIZE = 512;

export function osmTileXY2LonLat(x, y, zoom) {
  var lon = x / Math.pow(2, zoom) * 360 - 180;
  var n = Math.PI - 2 * Math.PI * y / Math.pow(2, zoom);
  var lat = 180 / Math.PI * Math.atan(0.5 * (Math.exp(n) - Math.exp(-n)));
  return [lon, lat];
} // function signedArea(ring: any[]) {
//   let sum = 0;
//   for (let i = 0, len = ring.length, j = len - 1, p1, p2; i < len; j = i++) {
//     p1 = ring[i];
//     p2 = ring[j];
//     sum += (p2.x - p1.x) * (p1.y + p2.y);
//   }
//   return sum;
// }
// function classifyRings(rings: any[]) {
//   const len = rings.length;
//   if (len <= 1) {
//     return [rings];
//   }
//   const polygons: any = [];
//   let polygon: any;
//   let ccw;
//   for (let i = 0; i < len; i++) {
//     const area = signedArea(rings[i]);
//     if (area === 0) {
//       continue;
//     }
//     if (ccw === undefined) {
//       ccw = area < 0;
//     }
//     if (ccw === area < 0) {
//       if (polygon) {
//         polygons.push(polygon);
//       }
//       polygon = [rings[i]];
//     } else {
//       polygon.push(rings[i]);
//     }
//   }
//   if (polygon) {
//     polygons.push(polygon);
//   }
//   return polygons;
// }
// const VectorTileFeatureTypes = ['Unknown', 'Point', 'LineString', 'Polygon'];
// function GetGeoJSON(z: number, vectorTileFeature: VectorTileFeature) {
//   const extent = vectorTileFeature.extent;
//   let coords = vectorTileFeature.loadGeometry() as any;
//   const currenType = vectorTileFeature.type;
//   const currentProperties = vectorTileFeature.properties;
//   const currentId = vectorTileFeature.id;
//   const size = extent * Math.pow(2, z);
//   let type = VectorTileFeatureTypes[currenType];
//   let i;
//   let j;
//   function project(line: any[]) {
//     for (let index = 0; index < line.length; index++) {
//       const point = line[index];
//       line[index] = [
//         (point.x / size) * TILE_SIZE,
//         (point.y / size) * TILE_SIZE,
//       ];
//     }
//   }
//   switch (currenType) {
//     case 1:
//       const points = [];
//       for (i = 0; i < coords.length; i++) {
//         points[i] = coords[i][0];
//       }
//       coords = points;
//       project(coords);
//       break;
//     case 2:
//       for (i = 0; i < coords.length; i++) {
//         project(coords[i]);
//       }
//       break;
//     case 3:
//       coords = classifyRings(coords);
//       for (i = 0; i < coords.length; i++) {
//         for (j = 0; j < coords[i].length; j++) {
//           project(coords[i][j]);
//         }
//       }
//       break;
//   }
//   if (coords.length === 1) {
//     coords = coords[0];
//   } else {
//     type = 'Multi' + type;
//   }
//   const result = {
//     type: 'Feature',
//     geometry: {
//       type,
//       coordinates: coords,
//     },
//     properties: currentProperties,
//     id: currentId,
//     tileOrigin: [0, 0],
//     coord: '',
//   };
//   return result;
// }

var getVectorTile = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, tileParams, tile) {
    var tileUrl;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            tileUrl = getURLFromTemplate(url, tileParams);
            return _context.abrupt("return", new Promise(function (resolve) {
              var xhr = getArrayBuffer({
                url: tileUrl
              }, function (err, data) {
                if (err || !data) {
                  // reject(err);
                  resolve({
                    layers: {}
                  });
                } else {
                  var vectorTile = new VectorTile(new Protobuf(data)); // check tile source layer
                  // console.log(vectorTile)
                  // const tileOrigin = osmTileXY2LonLat(
                  //   tileParams.x,
                  //   tileParams.y,
                  //   tileParams.z,
                  // );
                  // const zoom = tileParams.z;

                  for (var _i = 0, _Object$keys = Object.keys(vectorTile.layers); _i < _Object$keys.length; _i++) {
                    var sourceLayer = _Object$keys[_i];
                    var features = [];
                    var vectorTileLayer = vectorTile.layers[sourceLayer];

                    for (var i = 0; i < vectorTile.layers[sourceLayer].length; i++) {
                      var vectorTileFeature = vectorTile.layers[sourceLayer].feature(i); // let feature;
                      // if (coord === 'lnglat') {

                      var feature = vectorTileFeature.toGeoJSON(tileParams.x, tileParams.y, tileParams.z); // } else {
                      //   feature = GetGeoJSON(zoom, vectorTileFeature);
                      //   // @ts-ignore
                      //   vectorTileLayer.l7TileOrigin = tileOrigin;
                      //   // @ts-ignore
                      //   vectorTileLayer.l7TileCoord = coord;
                      // }

                      features.push(feature);
                    } // @ts-ignore


                    vectorTileLayer.features = features;
                  }

                  resolve(vectorTile);
                }
              });

              tile.xhrCancel = function () {
                return xhr.abort();
              };
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getVectorTile(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

export default function mapboxVectorTile(data, cfg) {
  // TODO: 后续考虑支持多服务
  var url = Array.isArray(data) ? data[0] : data; // const coord = cfg?.coord || 'lnglat'; // lnglat - offset

  var getTileData = function getTileData(tileParams, tile) {
    return getVectorTile(url, tileParams, tile);
  }; // getVectorTile(data, tileParams, tile, coord);


  var tilesetOptions = _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_CONFIG), cfg), {}, {
    getTileData: getTileData
  });

  return {
    data: url,
    dataArray: [],
    tilesetOptions: tilesetOptions,
    isTile: true
  };
}